import { render, staticRenderFns } from "./BulkInventoryItemTable.vue?vue&type=template&id=0c0cabeb&scoped=true"
import script from "./BulkInventoryItemTable.vue?vue&type=script&lang=ts"
export * from "./BulkInventoryItemTable.vue?vue&type=script&lang=ts"
import style0 from "./BulkInventoryItemTable.vue?vue&type=style&index=0&id=0c0cabeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0cabeb",
  null
  
)

export default component.exports